import type { FilterChip } from '@/components/filter-bar'
import type { ListarOperadoresQuery, StatusOperador } from '@/types/operador'
import { STATUS_OPERADOR } from '@/types/operador'

export interface FiltroOperadores {
  busca: string
  situacao: StatusOperador
}

export const filtroVazio: FiltroOperadores = {
  busca: '',
  situacao: STATUS_OPERADOR.Todas,
}

const CAMPOS_PAINEL = ['situacao'] as const

const preenchido = (campo: keyof FiltroOperadores, filtro: FiltroOperadores): boolean =>
  campo === 'situacao' ? filtro.situacao !== STATUS_OPERADOR.Todas : filtro[campo].trim() !== ''

export const contarFiltrosDoPainel = (filtro: FiltroOperadores): number =>
  CAMPOS_PAINEL.filter((campo) => preenchido(campo, filtro)).length

export const paraFiltroApi = (
  filtro: FiltroOperadores,
  pageSize: number,
): ListarOperadoresQuery => ({
  pageNumber: 1,
  pageSize,
  busca: filtro.busca || null,
  situacao: filtro.situacao,
})

const ROTULOS: Record<keyof FiltroOperadores, string> = {
  busca: 'Busca',
  situacao: 'Situação',
}

export const montarChips = (
  filtro: FiltroOperadores,
  remover: (campo: keyof FiltroOperadores) => void,
): FilterChip[] =>
  (['busca', ...CAMPOS_PAINEL] as (keyof FiltroOperadores)[])
    .filter((campo) => preenchido(campo, filtro))
    .map((campo) => ({
      key: campo,
      label: ROTULOS[campo],
      value: filtro[campo],
      onRemove: () => remover(campo),
    }))
